import React from 'react'
import Select from 'react-select'
import { get, some, every, isEmpty, filter, isPresent } from 'lodash'

const filteredData = ({ clusters, filters }) => filter(clusters, (cluster) => {
  const filterResults = {}

  if (filters.locations != 'all') {
    filterResults['locations'] = some(filters.locations, location => location.value === get(cluster, 'location_id'))
  }

  if (filters.haEnabled != 'all') {
    filterResults['haEnabled'] = filters.haEnabled === get(cluster, 'ha_enabled')
  }

  if (filters.admissionControlEnabled != 'all') {
    filterResults['admissionControlEnabled'] = filters.admissionControlEnabled === get(cluster, 'admission_control_enabled')
  }

  if (filters.drsEnabled != 'all') {
    filterResults['drsEnabled'] = filters.drsEnabled === get(cluster, 'drs_enabled')
  }


  return (every(filterResults, (value, _key) => value === true) || isEmpty(filterResults))
})

const ClusterReportFilters = ({ filters, changeFilters, filterOptions }) => (
  <div className="container-fluid" style={{ marginTop: '10px', marginBottom: '10px' }}>
    <div className='row'>
      <div className="col">
        Location
        <Select
          id='clusterlocationFilter'
          isMulti
          value={filters.locations}
          options={filterOptions.locations}
          onChange={options => {
            let locations = options
            if (isEmpty(options)) { locations = 'all' }

            changeFilters({ ...filters, locations })
          }}
        />
      </div>
    </div>
  </div>
)

export { ClusterReportFilters, filteredData }
